import React from "react";
import { Router, Route, Switch, Redirect } from "react-router-dom";
import {  } from "mdb-react-ui-kit";
import { history } from "../../_helpers";
import { PrivateRoute } from "../../_components";

import "./App.css";

import Header from "../Header";
import Footer from "../Footer";

import {
  LoginForm,
  RegisterForm,
  RestorePasswordForm,
  ChangePasswordForm,
  AddUserForm,
  EditUserForm,
  DeleteUserConfirmForm
} from "../Forms";

import {
  HomePage,
  AboutPage,
  PricePage,
  ContactPage,
  ServicesPage,
  PortfolioPage,
  PortfolioItemPage,
  CertificatesPage,
  SchedulePage,
  UsersPage,
  ClientsPage,
  AccountsPage,
  ProfilePage,
  SentVerificationEmailNotificationPage,
  RegistrationConfirmedPage,
  RecoveryPasswordConfirmationPage,
  PasswordChangedSuccessfullyPage,
} from "../Pages";

const App = () => {
  return (
    <Router history={history}>
      <div className="stylist-app">
        <Header />
        <div className="wrapper">
          <Switch>
            <Route path="/" exact component={HomePage} />
            <Route path="/about" component={AboutPage} />
            <Route path="/price" component={PricePage} />
            <Route path="/services" component={ServicesPage} />
            <Route path="/portfolio" component={PortfolioPage} />
            <Route path="/portfolioitem/:portfolioId" component={PortfolioItemPage} />
            <Route path="/certificates" component={CertificatesPage} />
            <Route path="/contact" component={ContactPage} />

            <Route path="/login" component={LoginForm} />
            <Route path="/register" component={RegisterForm} />
            <Route path="/restore-password" component={RestorePasswordForm} />
            <PrivateRoute
              path="/change-password"
              component={ChangePasswordForm}
            />

            <PrivateRoute path="/add-user" component={AddUserForm} />
            <PrivateRoute path="/edit-user/:id" component={EditUserForm} />
            <PrivateRoute path="/users/:id" component={EditUserForm} />
            <PrivateRoute
              path="/delete-user-confirm"
              component={DeleteUserConfirmForm}
            />

            <PrivateRoute path="/schedule" component={SchedulePage} />
            <PrivateRoute path="/users" component={UsersPage} />
            <PrivateRoute path="/clients" component={ClientsPage} />
            <PrivateRoute path="/accounts" component={AccountsPage} />
            <PrivateRoute path="/profile" component={ProfilePage} />

            <Route
              path="/sent-verification-email-notification"
              component={SentVerificationEmailNotificationPage}
            />
            <Route
              path="/registration-confirmed"
              component={RegistrationConfirmedPage}
            />
            <Route
              path="/recovery-password-confirmation"
              component={RecoveryPasswordConfirmationPage}
            />
            <PrivateRoute
              path="/password-changed-successfully"
              component={PasswordChangedSuccessfullyPage}
            />
            <Redirect from="*" to="/" />
          </Switch>
        </div>
        <Footer />
      </div>
    </Router>
  );
};
export default App;
